const CalendarFeatured = ({ children }) => {
    return (
        <div className="main-content__calendar-events main-content__calendar-events--daily">
            {children}
        </div>
    );
};

export default CalendarFeatured;
